<template>
  <v-container
    class="mb-8"
    data-aos="fade"
  >
    <h1 class="text-center mb-8">Gallery</h1>
    <v-row>
      <v-col
       v-for="(image, key) in images"
       :key="key"
       class="d-flex child-flex"
       cols="6"
       sm="4"
       lg="3"
      >
        <v-img
          :lazy-src="image.thumbnail"
          :src="image.url"
          aspect-ratio="1"
          class="grey lighten-2"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GalleryDocument } from '@/utils/types'
import {
  VCol,
  VContainer,
  VImg,
  VProgressCircular,
  VRow,
} from 'vuetify/lib'

export default {
  components: {
    VCol,
    VContainer,
    VImg,
    VProgressCircular,
    VRow,
  },
  data: () => ({
    images: [],
    loading: true,
  }),
  mounted() {
    this.$bind('images', GalleryDocument.list())
        .then(() => this.loading = false)
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>
